var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGridAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.125 18H18.125V30H30.125V18Z",
    fill: "#cccccc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1254 0H0.125366V12H12.1254V0Z",
    fill: "#cccccc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 18H0.125V30H12.125V18Z",
    fill: "#cccccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.125 0H18.125V12H30.125V0Z",
    fill: "#cccccc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridAlt);
export default __webpack_public_path__ + "static/media/grid-alt.e01d04273e93affb46c0eba8b910f82d.svg";
export { ForwardRef as ReactComponent };